export interface Category {
  id: string;
  label: string;
  mobileLabel: string;
}

export const JOB_CATEGORIES: Category[] = [
  { id: '大手事業会社', label: '大手事業会社', mobileLabel: '大手\n事業会社' },
  {
    id: 'メガベンチャー',
    label: 'メガベンチャー',
    mobileLabel: 'メガ\nベンチャー'
  },
  { id: 'SIer', label: 'SIer', mobileLabel: 'SIer' },
  { id: 'コンサル', label: 'コンサル', mobileLabel: 'コンサル' }
];
